import React from "react";
import './App.scss';
import Index from './routes';
import headerBg from "../src/assets/images/header-bg.png";
import footerBg from "../src/assets/images/footer-bg.png";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
// import landingPageBg from "../src/assets/images/landingPageBg.jpeg";
function App() {
  return (
    <div className="app">
      {/* <Login />
      <SignUp /> */}
      <Index />
      <span><img src={headerBg} alt="" className="header-bg" /></span>
      <span><img src={footerBg} alt="" className="footer-bg" /></span>
    </div>
  );
}

export default App;
